// extracted by mini-css-extract-plugin
export default {"TitleDialogContent":"ModalEstado_TitleDialogContent__1JT6v","TitleDialogTexto":"ModalEstado_TitleDialogTexto__SDEyZ"};